import { mergeAttributes, Node } from '@tiptap/react';

const SingleColumnNode = Node.create({
    name: 'single_column',
    content: 'block*',
    group: 'block',
    defining: true,
    isolating: true,

    parseHTML() {
        return [
            {
                tag: 'div',

                // Parsing priorities start at 50, single columns
                // have a higher priority that two columns.
                priority: 70,

                getAttrs: (element) => {
                    if (element instanceof HTMLElement) {
                        const type = element.getAttribute('data-type');
                        if (type === 'single-column') {
                            return null;
                        }
                    }

                    return false;
                },
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return [
            'div',
            mergeAttributes(
                this.options.HTMLAttributes,
                HTMLAttributes,
                { style: 'padding: 10px' },
                { 'data-type': 'single-column' }
            ),
            0,
        ];
    },
});

export default SingleColumnNode;
